import React from 'react';
import { Steps, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import classes from './RegistrationTimeline.module.scss';
import { CheckOutlined } from '@ant-design/icons';

interface RegistrationTimelineProps {
  currentStep: 0 | 1 | 2 | 3; // 0-3 (соответствует этапам 1-4)
}

const RegistrationTimeline: React.FC<RegistrationTimelineProps> = ({
  currentStep,
}) => {
  const { t } = useTranslation();

  const stepsData = [
    {
      title: '30%',
      description: t('registrationTimeline.step1'),
    },
    {
      title: '60%',
      description: t('registrationTimeline.step2'),
    },
    {
      title: '90%',
      description: t('registrationTimeline.step3'),
    },
    {
      title: '100%',
      description: t('registrationTimeline.step4'),
    },
  ];

  const getStepStatus = (index: number): any['status'] => {
    if (index === currentStep) return 'process';
    if (index < currentStep) return 'finish';
    return 'wait';
  };

  const items: any[] = stepsData.map((step, index) => ({
    title: step.title,
    icon: (
      <Tooltip title={step.description} placement='top'>
        <div className={classes.stepIcon}>
          { getStepStatus(index) === 'finish' ? <CheckOutlined /> : index + 1}
        </div>
      </Tooltip>
    ),
  }));

  return (
    <div className={classes.timelineContainer}>
      <Steps
        titlePlacement='vertical'
        current={currentStep}
        items={items}
        className={classes.steps}
      />
    </div>
  );
};

export default RegistrationTimeline;
